import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "system_introduct_container" }
const _hoisted_2 = { class: "system_introduct_container_box_name" }
const _hoisted_3 = { class: "system_introduct_container_box_description" }
const _hoisted_4 = { style: {"height":"100%"} }
const _hoisted_5 = { class: "system_introduct_container_detailbox_title" }
const _hoisted_6 = { class: "system_introduct_container_detailbox_title_name" }
const _hoisted_7 = ["src"]
const _hoisted_8 = { class: "system_introduct_container_detailbox_body" }
const _hoisted_9 = { class: "system_introduct_container_detailbox_body_content" }
const _hoisted_10 = { class: "system_introduct_container_detailbox_body_content_item_name" }
const _hoisted_11 = { class: "system_introduct_container_detailbox_body_footer" }
const _hoisted_12 = {
  key: 0,
  style: {"margin-left":"7px"}
}
const _hoisted_13 = {
  key: 1,
  style: {"margin-left":"7px","color":"#ccc"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SvgIcon = _resolveComponent("SvgIcon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["system_introduct_container_box", 
        _ctx.hasApplicationPermission(_ctx.itemBoxData.applicationCode)
          ? ''
          : 'system_introduct_container_no-permission'
      ]),
      style: _normalizeStyle(_ctx.currentIndex === 3 ? 'border-right:none' : '')
    }, [
      _createVNode(_component_SvgIcon, {
        name: _ctx.itemBoxData.icon,
        size: "80 82",
        style: {"margin-top":"61px"}
      }, null, 8, ["name"]),
      _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.itemBoxData.name), 1),
      _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.itemBoxData.description), 1)
    ], 6),
    _createElementVNode("div", {
      class: _normalizeClass(["system_introduct_container_detailbox", 
        _ctx.hasApplicationPermission(_ctx.itemBoxData.applicationCode)
          ? ''
          : 'system_introduct_container_no-permission'
      ]),
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.goSystemByhref(_ctx.itemBoxData)))
    }, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.itemBoxData.name), 1),
          _createElementVNode("img", {
            src: `${_ctx.FILESERVICE}/file/4pl/webclient/img/system-introduct-title-bg.png`,
            style: {"width":"330px","display":"block"},
            alt: "text/png"
          }, null, 8, _hoisted_7)
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.itemBoxData.hoverContent, (item, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: index,
                class: "system_introduct_container_detailbox_body_content_item",
                style: _normalizeStyle(_ctx.currentIndex === 3 ? 'width:160px' : '')
              }, [
                _createVNode(_component_SvgIcon, {
                  name: item.hoverIcon,
                  size: "40 40"
                }, null, 8, ["name"]),
                _createElementVNode("div", _hoisted_10, _toDisplayString(item.hoverName), 1)
              ], 4))
            }), 128))
          ]),
          _createElementVNode("div", _hoisted_11, [
            (_ctx.itemBoxData.onClickHandle)
              ? (_openBlock(), _createElementBlock("a", _hoisted_12, "查看详情→"))
              : (_openBlock(), _createElementBlock("a", _hoisted_13, "查看详情→"))
          ])
        ])
      ])
    ], 2)
  ]))
}